import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Alarm/Alarm_Server/SuccessBox';
import ASTable from 'components/Web_User_Interface/1080p_Series/Alarm/Alarm_Server/asTable';
import PrimaryBox from 'components/Web_User_Interface/1080p_Series/Alarm/Alarm_Server/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  ASTable,
  PrimaryBox,
  BreadCrumbs,
  SEOHelmet,
  React
};